import type { RouteId } from '../router';

export interface NavLink {
  readonly id: RouteId;
  readonly label: string;
  readonly icon: string;
}

export const NAV_LINKS: readonly NavLink[] = [
  { id: 'accueil', label: 'Accueil', icon: '🏠' },
  { id: 'personnage', label: 'Personnage', icon: '🧑' },
  { id: 'profils', label: 'Profils', icon: '⚔' },
  { id: 'peuples', label: 'Peuples', icon: '🧝' },
  { id: 'prestige', label: 'Prestige', icon: '★' },
  { id: 'equipement', label: 'Équipement', icon: '🛡' },
  { id: 'bestiaire', label: 'Bestiaire', icon: '🐉' },
  { id: 'religions', label: 'Religions', icon: '⛪' },
  { id: 'regles', label: 'Règles', icon: '📖' },
  { id: 'aventure', label: 'Aventure', icon: '🧭' },
  { id: 'univers', label: 'Univers', icon: '🌍' },
  { id: 'glossaire', label: 'Glossaire', icon: '📚' },
];
